module.exports = __webpack_public_path__ + "img/illo_1.c0b86966.svg";